// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27HPf","field":"styles_field__2LJGk","fieldCol":"styles_fieldCol__1ayKa","diffCol":"styles_diffCol__3j2Ug","diff":"styles_diff__1zJgU"};